module.exports = __webpack_public_path__ + "static/img/chanta (12).0897b91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (12).jpg
// module id = +wor
// module chunks = 0